import { PayloadAction } from "@reduxjs/toolkit";
import { SetCustomFilterValuePayload } from "./request";
import { IActivityHistoryCustomFilter } from "../../model";

export function setCustomFilterValueReducer(
  state,
  action: PayloadAction<SetCustomFilterValuePayload>,
) {
  state.filters = state.filters.map((f) => {
    if (f.id === action.payload.filterGroupId) {
      return {
        ...f,
        filters: f.filters.map((ff) =>
          ff.id === action.payload.filterId
            ? ff.singleOption
              ? setSingleOptionFilterValue(ff, action.payload.enabled)
              : setMultipleOptionsFilterValue(ff, action.payload)
            : ff,
        ),
      };
    }
    return f;
  });
}

const setMultipleOptionsFilterValue = (
  filter: IActivityHistoryCustomFilter,
  payload: SetCustomFilterValuePayload,
) => {
  const { optionId, enabled } = payload;
  //Si el option ya estaba habilitado, no cambiamos nada
  if (filter.enabledValues?.some((id) => id === optionId) && enabled) return filter;
  //Si no hay option id, devolvemos enabledValues vació, para evitar meter un undefined
  if(optionId === undefined || optionId === null)
    return {
      ...filter,
      enabledValues: [],
    };
  return {
    ...filter,
    enabledValues: enabled
      ? [...(filter.enabledValues || []), optionId]
      : filter.enabledValues.filter((id) => id !== optionId),
  };
};

const setSingleOptionFilterValue = (filter, value: boolean) => {
  return {
    ...filter,
    enabled: value,
    enabledValues: value ? [true] : [],
  };
};
